import { withInstall, withNoopInstall } from '@zoryn/utils'
import Menu from './src/menu'
import MenuItem from './src/menu-item.vue'
import MenuItemGroup from './src/menu-item-group.vue'
import SubMenu from './src/sub-menu'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZMenu: SFCWithInstall<typeof Menu> & {
  MenuItem: typeof MenuItem
  MenuItemGroup: typeof MenuItemGroup
  SubMenu: typeof SubMenu
} = withInstall(Menu, {
  MenuItem,
  MenuItemGroup,
  SubMenu,
})
export default ZMenu
export const ZMenuItem: SFCWithInstall<typeof MenuItem> =
  withNoopInstall(MenuItem)
export const ZMenuItemGroup: SFCWithInstall<typeof MenuItemGroup> =
  withNoopInstall(MenuItemGroup)
export const ZSubMenu: SFCWithInstall<typeof SubMenu> =
  withNoopInstall(SubMenu)

export * from './src/menu'
export * from './src/menu-item'
export * from './src/menu-item-group'
export * from './src/sub-menu'
export * from './src/types'
export * from './src/instance'
export * from './src/tokens'
